export default __webpack_public_path__ + "assets/images/onboarding/be449ed7a41aa7a1a43f4b3b4c6f69ba.mp4";